import React from 'react';
import clsx from 'clsx';
import type { BagelAiFlowNode } from '../../types/aiFlow';
import FLOW_NODE_KIND_LABEL from '../../utils/flowNodeKindLabels';
import styles from './AiFlowTab.module.scss';

type Props = {
  nodes: BagelAiFlowNode[];
  highlightedPath: string[];
  onNodeClick: (node: BagelAiFlowNode) => void;
};

export default function AiFlowMobileList({
  nodes,
  highlightedPath,
  onNodeClick,
}: Props) {
  const highlighted = new Set(highlightedPath);

  return (
    <ol className={styles.mobileList}>
      {nodes.map((node, index) => (
        <li key={node.id} className={styles.mobileListItem}>
          <button
            type="button"
            className={clsx(
              styles.mobileNodeButton,
              highlighted.has(node.id) && styles.mobileNodeHighlighted,
            )}
            onClick={() => onNodeClick(node)}
            title={node.description}
          >
            <span className={styles.mobileStep}>{index + 1}</span>
            <span className={styles.mobileNodeBody}>
              <span className={styles.mobileNodeTitle}>{node.title}</span>
              <span className={styles.mobileNodeKind}>{FLOW_NODE_KIND_LABEL[node.kind]}</span>
              {node.description ? (
                <span className={styles.mobileNodeDesc}>{node.description}</span>
              ) : null}
            </span>
          </button>
        </li>
      ))}
    </ol>
  );
}
